import {
  WISH_LIST_FETCH,
  WISH_LIST_FETCH_SUCCESS,
  WISH_LIST_FETCH_RESET,
  WISH_LIST_SEND_STATUS,
} from "./types";

export const wishListFetch = (id) => {
  return {
    type: WISH_LIST_FETCH,
    payload: id,
  };
};

export const wishListFetchSuccess = (payload) => {
  return {
    type: WISH_LIST_FETCH_SUCCESS,
    payload: payload,
  };
};

export const wishListFetchReset = () => {
  return {
    type: WISH_LIST_FETCH_RESET,
  };
};

export const wishListSendStatus = (payload) => {
  return {
    type: WISH_LIST_SEND_STATUS,
    payload: payload,
  };
};
